import React, { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import CookieConsent from '@/components/CookieConsent';
import FloatingActions from '@/components/FloatingActions';
import { useI18n } from '@/i18n/LanguageContext';
import { trackPageView } from '@/lib/tracking';


const SiteShell: React.FC = () => {
  const { fading } = useI18n();
  const location = useLocation();
  const last = useRef<string>('');

  // Anonymous, first-party page-view tracking. No fingerprinting, no third
  // party pixels — see src/lib/tracking.ts. Fire-and-forget so navigation is
  // never delayed by the tracking call.
  useEffect(() => {
    const key = location.pathname + location.search;
    if (last.current === key) return;
    last.current = key;
    trackPageView();
  }, [location.pathname, location.search]);

  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      <Header />
      <main className={`flex-1 transition-opacity duration-200 ${fading ? 'opacity-0' : 'opacity-100'}`}>
        <Outlet />
      </main>
      <Footer />
      <CookieConsent />
      {/* Sticky conversion actions: Start Now (plan picker) + WhatsApp. */}
      <FloatingActions />
    </div>

  );
};

export default SiteShell;
